import {
  container,
//cardTitle,
//whiteColor,
//grayColor,
  ts_main
} from "assets/jss/material-dashboard-pro-react.jsx";

const TransferOnlineLoginStyle = theme => ({
  container: {
    ...container,
    backgroundColor: "#FFFFFF",
    zIndex: "4",
    [theme.breakpoints.down("sm")]: {
      paddingTop: "0px",
      paddingBottom: "0px"
    }
  },
  labelHeader: {
    marginTop        : 10,
    marginBottom     : 10,
    fontSize         : "1.7rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "300",
    color            : "#FFDD00",
    textAlign        : "center",
  },
  labelSubHeader: {
    marginTop        : 2,
    marginBottom     : 2,
    fontSize         : "1rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "100",
    color            : "#303030",
    textAlign        : "center",
    "vertical-align" : "middle",
  },
  logo: {
    margin           : "1rem 0",
    "& img"          : {
      width   : "25%",
      display : "block",
      margin  : "auto"
    },
    "& span"          : {
      width        : "100px",
      height       : "1px",
      borderBottom : "3px solid " + ts_main[3],
      display      : "block",
      margin       : "1rem auto"
    }
  },
  loginEmail: {
    marginTop        : 10,
    marginBottom     : 10,
    input            : { color : "303030" },
    "& input": {
      "-webkit-box-shadow": "none",
    },
    "& input:-webkit-autofill": {
      "-webkit-box-shadow": "0 0 0 1000px white inset !important",
      "-webkit-text-fill-color": "black !important",
    },
    "& input:-webkit-autofill:hover": {
      "-webkit-box-shadow": "0 0 0 1000px white inset !important",
      "-webkit-text-fill-color": "black !important",
    },
    "& input:-webkit-autofill:focus": {
      "-webkit-box-shadow": "0 0 0 1000px white inset !important",
      "-webkit-text-fill-color": "black !important",
    },
    "& input::-ms-reveal": {
      display: "none",
    },
    "& input::-ms-clear": {
      display: "none",
    },
  },
  loginPassword: {
    marginTop        : 10,
    marginBottom     : 10,
    input            : { color : "303030" },
    "& input": {
      "-webkit-box-shadow": "none",
    },
    "& input:-webkit-autofill": {
      "-webkit-box-shadow": "0 0 0 1000px white inset !important",
      "-webkit-text-fill-color": "black !important",
    },
    "& input:-webkit-autofill:hover": {
      "-webkit-box-shadow": "0 0 0 1000px white inset !important",
      "-webkit-text-fill-color": "black !important",
    },
    "& input:-webkit-autofill:focus": {
      "-webkit-box-shadow": "0 0 0 1000px white inset !important",
      "-webkit-text-fill-color": "black !important",
    },
    "& input::-ms-reveal": {
      display: "none",
    },
    "& input::-ms-clear": {
      display: "none",
    },
  },
  yellowButton: {
    fontSize         : "0.9rem",
    textTransform    : "none",
    marginTop        : 50,
    marginBottom     : 20,
    color            : "#303030",
    backgroundColor  : "#FFDD00",
    width            : "100%",
    'border-radius'  : "25px",
    "&:hover"        : { fontWeight:"600", color:"#303030", background: "#FFDD00 !important"},
    "&:focus"        : { fontWeight:"600", color:"#303030", background: "#FFDD00 !important"},
  },
  popupOkButton: {
    textTransform   : "none",
    backgroundColor : "#FFDD00",
    'border-radius' : "10px"
  },
  dontHaveAccount: {
    marginTop        : 10,
    marginBottom     : 0,
    fontSize         : "1rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "300",
    color            : "#303030",
    textAlign        : "center",
    "vertical-align" : "middle",
  },
  //----------
  //PleaseWait
  //----------
  pleaseWait: {
    marginTop        : 50,
  //marginBottom     : 0,
    fontSize         : "1rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "300",
    color            : "#303030",
    textAlign        : "center",
    display          : "flex",
    alignItems       : "center",
    justifyContent   : "center",
  },
  //------------
  //viewSteps3/4
  //------------
  viewSteps3Image: {
    margin: "0rem 0",
    "& img": {
      width: "75%",
      display: "block",
      margin: "auto"
    },
    "& span": {
      width: "100px",
      height: "1px",
      borderBottom: "3px solid " + ts_main[3],
      display: "block",
      margin: "1rem auto"
    }
  },
  viewSteps4Image: {
    margin: "0rem 0",
    "& img": {
      width: "75%",
      display: "block",
      margin: "auto"
    },
    "& span": {
      width: "100px",
      height: "1px",
      borderBottom: "3px solid " + ts_main[3],
      display: "block",
      margin: "1rem auto"
    }
  },
  viewSteps4ImageDots: {
    "& img": {
      width: "200%",
      display: "block",
      margin: "auto"
    },
  },
  viewSteps3Label: {
    fontSize     : "0.75rem",
    fontFamily   : '"Helvetica"',
    fontWeight   : "200",
    color        : "#303030",
    textAlign    : "center",
    "vertical-align":"middle",
  },
  viewSteps4Label: {
    fontSize     : "0.75rem",
    fontFamily   : '"Helvetica"',
    fontWeight   : "200",
    color        : "#303030",
    textAlign    : "center",
    "vertical-align":"middle",
  },
  //---------
  //HONEYMOON
  //---------
  GridItemTextField0 : {
      opacity   : 0,
      position  : "absolute",
      top       : 0,
      left      : 0,
      height    : 0,
      width     : 0,
      "z-index" : -1,
  },
});

export default TransferOnlineLoginStyle;
